import React, {type SVGProps} from 'react'

const StepErrorLined = (props: SVGProps<SVGSVGElement>) => {
  return (
    <>
      <svg
        style={{display: 'inline'}}
        width="11"
        height="12"
        viewBox="0 0 11 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.3388 3.06066C10.9246 2.47487 10.9246 1.52513 10.3388 0.93934C9.75305 0.353553 8.8033 0.353553 8.21751 0.93934L5.3895 3.76735L2.56149 0.93934C1.97571 0.353553 1.02596 0.353553 0.440171 0.93934C-0.145615 1.52513 -0.145615 2.47487 0.440171 3.06066L3.26818 5.88867L0.43934 8.71751C-0.146446 9.3033 -0.146447 10.253 0.43934 10.8388C1.02513 11.4246 1.97487 11.4246 2.56066 10.8388L5.3895 8.00999L8.21835 10.8388C8.80413 11.4246 9.75388 11.4246 10.3397 10.8388C10.9255 10.253 10.9255 9.3033 10.3397 8.71751L7.51082 5.88867L10.3388 3.06066Z"
          fill="currentColor"
        />
      </svg>
    </>
  )
}
export default StepErrorLined
